import _ from 'lodash';
import classNames from 'classnames';

import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Button, Typography } from '@material-ui/core';
import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined';
import { MouseClickEvent } from 'types';
import { COLOR } from 'config/constants';
import { HvIconButton, HvSearchInput } from 'components';

const useStyles = makeStyles({
  titleBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '@media (max-width: 767px)': {
      flexDirection: 'column',
    },
  },
  titleBox: {
    display: 'flex',
    alignItems: 'center',

    '@media (max-width: 767px)': {
      justifyContent: 'space-between',
      width: '100%',
      marginBottom: 20,
    },
  },
  title: {
    color: COLOR.WHITE,
  },
  plusButton: {
    marginLeft: 20,
    color: COLOR.WHITE,
    backgroundColor: COLOR.LIGHT_BLUE,
    '& p': {
      fontSize: 12,
    },
    '@media (max-width: 768px)': {
      marginRight: 0,
      width: '50%',
    },
    '&:hover': {
      backgroundColor: COLOR.DARK_BLUE,
    },
  },
  dateIcon: {
    marginRight: 5,
  },
  searchBox: {
    '@media (min-width: 768px)': {
      width: '50%',
    },
    '@media (max-width: 767px)': {
      width: '100%',
    },
  },
  searchInput: {
    width: '100%',
  },
});

interface Props {
  className: string;
  hideSearchBar: boolean;
  onSearch: (s: string) => void;
  onNewShooting: (e: MouseClickEvent) => void;
}

function TitleBar({ className, hideSearchBar, onSearch, onNewShooting }: Props) {
  const intl = useIntl();
  const styles = useStyles();

  const fmtTitle = intl.formatMessage({ id: 'shootings.title' });
  const fmtPlaceholder = intl.formatMessage({ id: 'shootings.search.placeholder' });
  const fmtSearchButton = intl.formatMessage({ id: 'search' });
  const fmtNewShooting = intl.formatMessage({ id: 'shooting.create.bookShooting' });

  return (
    <Box className={classNames(className, styles.titleBar)}>
      <Box className={styles.titleBox}>
        <h2>{fmtTitle}</h2>
        <HvIconButton
          className={styles.plusButton}
          icon='calendar_plus'
          onClick={onNewShooting}
          text={fmtNewShooting}
        />
      </Box>

      <Box className={styles.searchBox}>
        {!hideSearchBar ? (
          <HvSearchInput
            className={styles.searchInput}
            placeholder={fmtPlaceholder}
            onChange={onSearch}
            onSearch={onSearch}
            buttonText={fmtSearchButton}
          />
        ) : null}
      </Box>
    </Box>
  );
}

TitleBar.defaultProps = {
  className: null,
  hideSearchBar: false,
  onSearch: _.noop,
  onNewShooting: _.noop,
};

TitleBar.propTypes = {
  className: PropTypes.string,
  hideSearchBar: PropTypes.bool,
  onSearch: PropTypes.func,
  onNewShooting: PropTypes.func,
};

export default TitleBar;
